<div class="app-list " [class]="containerClass" (dblclick)="config?.dbclick()">
  <div (click)="config?.click()"
       class="typo-container-s-s-q  typo-small typo-left app-space-left_none" >
    <span class="">
      {{enumSvc.getEnumerationText('ReceiptStatus', receipt['rcpt_enmIdent_ReceiptStatus'])}}
      - {{enumSvc.getEnumerationText('ReceiptType', receipt['rcpt_enmIdent_ReceiptType'])}}
    </span>
    <span></span>
    <q></q>
    <span class="app-list-row-boldline">
      {{receipt['rcptDate'] | excDate: 'dd.MM.yyyy'}}
      {{!receipt['rcptDate'] ? getRessource('EmptyColumn.rcptDate') : ''}}&nbsp;|&nbsp;
      {{receipt['rcptNumber'] ? 'Beleg - ' + receipt['rcptNumber'] : getRessource('EmptyColumn.rcptNumber')}}
    </span>
    <span></span>
    <q></q>
    <span>
      {{receipt['rcptFileName']}}
    </span>
    <span></span>
    <q></q>
    <ng-container *ngIf="receipt['rcptDesc']?.toString().length > 0">
      <span class="list-secondary-text app-list-text">
        {{receipt['rcptDesc']?.toString().slice(0, 48)}}{{receipt['rcptDesc']?.length >= 48 ? '...' : ''}}
      </span>
      <span></span>
      <q></q>
    </ng-container>
  </div>
  <div class="layout-1-auto app-pad-right">
    <div class="list-metadata space-right" (click)="config?.click()">
      <div class="typo-right">{{receipt['rcptLCD'] | excDate: 'dd.MM.yy HH:mm'}}</div>
      <div class="typo-right">{{receipt['rcptLCU']}}</div>
    </div>
    <div class="app-tree-point app-space-top_1" #VCThreePointMenue
         *ngIf="config?.actions">
      <ng-container  *ngIf="receipt['expandThreePointMenue'] && config['action'].length > 0">
        <ng-container *ngFor="let act of config['action']">
          <div *ngIf="act.visible">
            <i class="search-action" [class]="act['icon']"
               (click)="receipt['expandThreePointMenue'] = false; act.action()"
               [class.disabled]="act['disabled']" [class.c-green]="act?.active"
            ></i>
          </div>
        </ng-container>
      </ng-container>
      <div [class.not-expand]="!receipt['expandThreePointMenue']"
           [class.expand]="receipt['expandThreePointMenue']">
        <i class="search-action far fa-ellipsis-v" (click)="config?.click(); receipt['expandThreePointMenue'] = !receipt['expandThreePointMenue'];">
        </i>
      </div>
    </div>
<!--    <div class="typo-right" *ngIf="config?.actions">-->
<!--      <i class="search-action far fa-ellipsis-v" [class.disabled]="!config?.singleSelect" [tooltip]="'Beleg Aktion'" flow="left"></i>-->
<!--&lt;!&ndash;      <i class="search-action fas fa-folder-upload" [class.disabled]="!config?.singleSelect"  [tooltip]="'aus Gruppe entfernen'" flow="left"></i>&ndash;&gt;-->
<!--&lt;!&ndash;      <i class="search-action fas fa-folder-download" [class.disabled]="!config?.singleSelect"  [tooltip]="'zu Gruppe adden'" flow="left"></i>&ndash;&gt;-->
<!--    </div>-->
  </div>
</div>
